import { FormEvent } from 'react'
import { Heading1, Paragraph } from '@entur/typography'
import { GridContainer, GridItem } from '@entur/grid'
import { PrimaryButton } from '@entur/button'
import { DownloadIcon } from '@entur/icons'
import { BannerAlertBox, useToast } from '@entur/alert'
import { space } from '@entur/tokens'
import { getApprenticeTicketRightsReport } from '../../api-clients/eba-clients'
import { useDownloadableApi } from '../../api-clients/client-hooks'
import { FetchState } from '../../api-clients/api-types'
import { tolLocalDateFormat } from '../../utils/date-utils'

const ApprenticeTicketRightTab = () => {
  const [downloadResponse, download] = useDownloadableApi(getApprenticeTicketRightsReport)
  const { addToast } = useToast()

  const downloadReport = async (event: FormEvent) => {
    event?.preventDefault()
    addToast({ variant: 'info', content: 'Laster ned rapport ...' })
    download({
      query: `?format=csv&year=${new Date().getFullYear()}`,
      backupFileName: `apprentice-ticket-rights-${tolLocalDateFormat(new Date())}.csv`,
    })
  }

  return (
    <div>
      <Heading1>Rapport for lærlingrettigheter</Heading1>
      <Paragraph>Rettigheter tatt ut i {new Date().getFullYear()}.</Paragraph>

      <form
        data-cy="apprentice-ticket-right-report-form"
        id="apprentice-ticket-right_report__form"
        onSubmit={downloadReport}
      >
        <GridContainer spacing="medium">
          <GridItem small={12} medium={6} large={6}>
            <PrimaryButton
              id="submit-btn"
              className="apprentice-ticket-right_report__form-button"
              data-cy="apprentice-ticket-right-report-download-csv"
              type="submit"
              loading={downloadResponse.status === FetchState.LOADING}
            >
              <DownloadIcon /> Last ned CSV
            </PrimaryButton>
          </GridItem>
        </GridContainer>
        {downloadResponse.status === FetchState.ERROR && (
          <BannerAlertBox
            variant="error"
            title="Kan ikke laste ned rapport"
            closable={true}
            style={{ marginBottom: space.large, marginTop: space.large }}
          >
            Prøv på nytt eller ta kontakt med Entur support om det vedvarer.
          </BannerAlertBox>
        )}
      </form>
    </div>
  )
}

export default ApprenticeTicketRightTab
